import styled, {css} from "styled-components";
import {
    DARK_MODE_BORDER,
    DARK_MODE_COMMON_TEXT_COLOR,
    DARK_MODE_HEADER_BACKGROUND
} from "../../../../constants/colorScheme";

const LicenceDatatableContainer = styled.div`
    ${
        props => props.darkMode && css`
            .ant-table-row-expand-icon {    
                background: ${DARK_MODE_HEADER_BACKGROUND};
                color: ${DARK_MODE_COMMON_TEXT_COLOR};
                border: ${DARK_MODE_BORDER};
            }        
        `
    }
    .ant-table-row-expand-icon:hover, 
    .ant-table-row-expand-icon:focus 
    {
        color: ${props => props.primaryColor};
    }
`;

export default LicenceDatatableContainer;

